import EntryContainer from './EntryContainer';
import Loading from '../../Shared/Loading';
import { WorkflowEngineConfig } from '../../WorkflowEngine/workflowEngineDictionary';

export default {
  container: <EntryContainer />,
  loadingView: <Loading sx={{ marginTop: '10px', marginLeft: '10px' }} />
} as WorkflowEngineConfig;
